import {HttpPromiseState} from '../../lib/helpers';
import {environment} from '../../lib/environment';
import {
  X1Language,
  X1LanguageUpdateModel,
  X2AgeCategory,
  X2AgeCategoryUpdateModel,
  X3Level,
  X3LevelUpdateModel,
  X4Unit,
  X4UnitUpdateModel,
  X5Lesson,
  X5LessonUpdateModel,
  X6Page,
  X6PageSnapshot,
  X6PageUpdateModel,
  X7PushableBlock,
  X7PushableBlockSnapshot,
  X7PushableBlockUpdateModel,
  X8Block,
  X8BlockUpdateModel,
  X9Content,
  X9ContentUpdateModel
} from '../models/content';
import {SuccessResponse} from '../models/response-model';
import {httpClient} from '../utils/httpClient';


class X1LanguageLoaders {
  list(): HttpPromiseState<X1Language[]> {
    let url = `${environment.apiServer}/content/language/list`;
    return httpClient.state.get<X1Language[]>(url);
  }

  get(id: string | number): HttpPromiseState<X1Language> {
    let url = `${environment.apiServer}/content/language/${id}`;
    return httpClient.state.get<X1Language>(url);
  }

  insert(model: X1LanguageUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/language/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X1LanguageUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/language/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/language/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  order(languageIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/language/order`;
    return httpClient.state.post<SuccessResponse>(url, languageIds);
  }

  orderChildren(languageId: number,
                ageCategoryIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/language/${languageId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, ageCategoryIds);
  }
}

class X2AgeCategoryLoaders {
  get(id: string): HttpPromiseState<X2AgeCategory> {
    let url = `${environment.apiServer}/content/age-category/${id}`;
    return httpClient.state.get<X2AgeCategory>(url);
  }

  insert(model: X2AgeCategoryUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/age-category/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X2AgeCategoryUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/age-category/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/age-category/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(ageCategoryId: number, levelIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/age-category/${ageCategoryId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, levelIds);
  }

}

class X3LevelLoaders {
  get(id: string): HttpPromiseState<X3Level> {
    let url = `${environment.apiServer}/content/level/${id}`;
    return httpClient.state.get<X3Level>(url);
  }

  insert(model: X3LevelUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/level/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X3LevelUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/level/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/level/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(levelId: number, unitIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/level/${levelId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, unitIds);
  }
}

class X4UnitLoaders {
  get(id: number): HttpPromiseState<X4Unit> {
    let url = `${environment.apiServer}/content/unit/${id}`;
    return httpClient.state.get<X4Unit>(url);
  }

  insert(model: X4UnitUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/unit/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X4UnitUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/unit/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/unit/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(unitId: number, lessonIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/unit/${unitId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, lessonIds);
  }
}

class X5LessonLoaders {
  get(id: number): HttpPromiseState<X5Lesson> {
    let url = `${environment.apiServer}/content/lesson/${id}`;
    return httpClient.state.get<X5Lesson>(url);
  }

  insert(model: X5LessonUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X5LessonUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(lessonId: number, pageIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson/${lessonId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, pageIds);
  }
}

class X5LessonSnapshotLoaders {
  get(id: number): HttpPromiseState<X6PageSnapshot> {
    let url = `${environment.apiServer}/content/lesson-snapshot/${id}`;
    return httpClient.state.get<X6PageSnapshot>(url);
  }

  take(lessonId: number, version: string): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson/${lessonId}/snapshot`;
    let model = {Version: version};
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, version: string): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson-snapshot/${id}`;
    let model = {Version: version};
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  activate(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson-snapshot/${id}/activate`;
    return httpClient.state.put<SuccessResponse>(url);
  }

  deactivate(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson-snapshot/${id}/deactivate`;
    return httpClient.state.put<SuccessResponse>(url);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/lesson-snapshot/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }
}

class X6PageLoaders {
  get(id: number): HttpPromiseState<X6Page> {
    let url = `${environment.apiServer}/content/page/${id}`;
    return httpClient.state.get<X6Page>(url);
  }

  insert(model: X6PageUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/page/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X6PageUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/page/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/page/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(pageId: number, blockIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/page/${pageId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, blockIds);
  }
}

class X6PageSnapshotLoaders {
  get(id: number): HttpPromiseState<X6PageSnapshot> {
    let url = `${environment.apiServer}/content/page-snapshot/${id}`;
    return httpClient.state.get<X6PageSnapshot>(url);
  }
}

class X7PushableBlockLoaders {
  get(id: number): HttpPromiseState<X7PushableBlock> {
    let url = `${environment.apiServer}/content/pushable-block/${id}`;
    return httpClient.state.get<X7PushableBlock>(url);
  }

  insert(model: X7PushableBlockUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/pushable-block/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X7PushableBlockUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/pushable-block/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/pushable-block/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(blockId: number, contentItemIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/pushable-block/${blockId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, contentItemIds);
  }
}

class X7PushableBlockSnapshotLoaders {
  get(id: number): HttpPromiseState<X7PushableBlockSnapshot> {
    let url = `${environment.apiServer}/content/pushable-block-snapshot/${id}`;
    return httpClient.state.get<X7PushableBlockSnapshot>(url);
  }
}

class X8BlockLoaders {
  get(id: number): HttpPromiseState<X8Block> {
    let url = `${environment.apiServer}/content/block/${id}`;
    return httpClient.state.get<X8Block>(url);
  }

  insertBal(model: X8BlockUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/block/insertBal`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  insert(model: X8BlockUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/block/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X8BlockUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/block/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/block/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  orderChildren(blockId: number, contentItemIds: number[]): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/block/${blockId}/order-children`;
    return httpClient.state.post<SuccessResponse>(url, contentItemIds);
  }
}

class X9ContentLoaders {
  get(id: number): HttpPromiseState<X9Content> {
    let url = `${environment.apiServer}/content/content/${id}`;
    return httpClient.state.get<X9Content>(url);
  }

  insert(model: X9ContentUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/content/insert`;
    return httpClient.state.post<SuccessResponse>(url, model);
  }

  update(id: number, model: X9ContentUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/content/${id}`;
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  delete(id: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/content/content/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }
}

class ContentLoadersClass {
  readonly x1language = new X1LanguageLoaders();
  readonly x2ageCategory = new X2AgeCategoryLoaders();
  readonly x3level = new X3LevelLoaders();
  readonly x4unit = new X4UnitLoaders();
  readonly x5lesson = new X5LessonLoaders();
  readonly x5lessonSnapshot = new X5LessonSnapshotLoaders();
  readonly x6page = new X6PageLoaders();
  readonly x6pageSnapshot = new X6PageSnapshotLoaders();
  readonly x7pushableBlock = new X7PushableBlockLoaders();
  readonly x7pushableBlockSnapshot = new X7PushableBlockSnapshotLoaders();
  readonly x8block = new X8BlockLoaders();
  readonly x9content = new X9ContentLoaders();
}

export const contentLoaders = new ContentLoadersClass();
